import { motion } from "framer-motion";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { useLang } from "@/lib/LanguageContext";

export default function Faq() {
    const { t } = useLang();
    const items = t("faq.items") || [];
    return (
        <section
            id="faq"
            className="py-24 md:py-40 bg-[#EBE5DA]"
            data-testid="faq-section"
        >
            <div className="container-x">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.9, ease: [0.19, 1, 0.22, 1] }}
                    className="grid grid-cols-12 gap-8 mb-16"
                >
                    <div className="col-span-12 md:col-span-5">
                        <div className="chapter-num mb-4">{t("faq.chapter")}</div>
                        <h2 className="font-serif text-5xl md:text-7xl text-[#2D2824] tracking-[-0.02em] leading-[0.98]">
                            {t("faq.title_pre")}
                            <em className="italic text-[#B48F57]">
                                {t("faq.title_em")}
                            </em>
                            {t("faq.title_post")}
                        </h2>
                    </div>
                    <div className="col-span-12 md:col-span-7 md:pt-6">
                        <p className="text-[15px] md:text-[17px] text-[#5C564D] leading-relaxed max-w-[52ch] font-light">
                            {t("faq.body")}
                        </p>
                    </div>
                </motion.div>

                <Accordion
                    type="single"
                    collapsible
                    className="border-t border-[#BBAE9A]"
                    data-testid="faq-accordion"
                >
                    {items.map((f, i) => (
                        <AccordionItem
                            value={`item-${i}`}
                            key={i}
                            className="border-b border-[#BBAE9A]"
                        >
                            <AccordionTrigger
                                className="text-left py-6 md:py-8 hover:no-underline group"
                                data-testid={`faq-trigger-${i}`}
                            >
                                <span className="flex items-baseline gap-6">
                                    <span className="chapter-num shrink-0">
                                        0{i + 1}
                                    </span>
                                    <span className="font-serif text-2xl md:text-3xl text-[#2D2824] tracking-tight group-hover:text-[#B48F57] transition-colors">
                                        {f.q}
                                    </span>
                                </span>
                            </AccordionTrigger>
                            <AccordionContent
                                className="pl-0 md:pl-16 pb-8 text-[15px] md:text-[16px] text-[#5C564D] leading-relaxed font-light max-w-[62ch]"
                                data-testid={`faq-content-${i}`}
                            >
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
}
